import { RawAttachmentFile } from "ts/api/attachmentFile";
import {
  decideTaskEmailReviewViaApiV2,
  LegacySignatureFormData,
} from "api/tasks/apiv2-task-actions";

/**
 * Email-reviewer decide — multi-reviewer tasks
 * (`TaskApprovalType.MULTIPLE_REVIEWERS`). BE auto-invites the next
 * sequential reviewer on approve.
 */
export type MultipleSubmitArgs = {
  showId: string;
  key: string;
  taskId?: string;
  standId?: string;
  approval: boolean;
  message?: string;
  organiserReactionFiles?: RawAttachmentFile[];
  /**
   * Optional signature attached to the approve verdict. BE persists
   * it on `task_signatures` keyed by the email reviewer; silently
   * ignored on reject/revise.
   */
  signature?: LegacySignatureFormData | null;
  /**
   * "Allow exhibitor to resubmit after approval" checkbox. On a multi-reviewer
   * queue only the reviewer whose approve closes it actually writes the flag.
   */
  allowResubmitAfterApproval?: boolean;
};

async function multipleSubmit({
  showId,
  key,
  taskId,
  standId,
  approval,
  message,
  organiserReactionFiles,
  signature,
  allowResubmitAfterApproval,
}: MultipleSubmitArgs) {
  await decideTaskEmailReviewViaApiV2({
    showId,
    key,
    taskId,
    standId,
    isApproved: approval,
    message,
    files: organiserReactionFiles,
    signature,
    allowResubmitAfterApproval,
  });
  return [];
}

export default multipleSubmit;
